export function setGridHeight (params) {
  console.log('setGridHeight', params)
  const { gridContainerElement, numberOfRows, maxRows = 10, includeFilterRow = false } = params

  const gridHeaderHeight = 49 + (includeFilterRow ? 48 : 0) + 1
  const gridRowHeight = 42
  const gridBufferHeight = 1
  const height = Math.min(maxRows, numberOfRows) * gridRowHeight +
    gridHeaderHeight +
    gridBufferHeight +
    (numberOfRows > maxRows ? 21 : 0) // Half size row to show there are more

  gridContainerElement.setAttribute('style', `height: ${height}px;`)
}
